import { isTabInFocus, removeStateFromUrl } from '@shared/utils/utils';
import { PageStateService } from '@shared/user-state/PageStateService';
import { Events, EventsGlobal } from '@shared/Events';

export class PageStateLiveUserState<T extends IPageState> {
    handler: IPageStateHandler<T> = null;

    lastState: IPageState = null;
    checkChangeTimer = null;

    constructor(handler: IPageStateHandler<T>) {
        this.handler = handler;
        Events.on(EventsGlobal.PROJECT_CHANGE_BEFORE, this.handleProjectChange);
    }

    handleProjectChange = () => {
        this.stopPolling();
        return this.saveNow();
    };

    startPolling = (checkChangeIntervalMS: number) => {
        clearInterval(this.checkChangeTimer);
        this.checkChangeTimer = setInterval(this.save, checkChangeIntervalMS);
    };

    equals(a: IPageState, b: IPageState): boolean {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    restoreState = (page: IPageStatePage) => {
        const req = PageStateService.liveState.fetch(page);
        req.then(state => {
            this.handler.restoreState(state);
        });
        return req;
    };

    save = async () => {
        if (!isTabInFocus()) return;
        return this.saveNow();
    };

    saveNow = async (): Promise<void> => {
        const currState = await this.handler.getCurrentState(false);

        if (this.lastState == null) {
            // first run
            this.lastState = currState;
        }

        if (!this.equals(currState, this.lastState)) {
            return PageStateService.liveState.saveOrUpdate(currState).then(
                () => {
                    this.lastState = currState;

                    // remove share key from url (after the state is changed) so that user can refresh the page normally
                    removeStateFromUrl();
                },
                () => {
                    // leave lastState untouched so the failed save is retried on the next tick
                }
            );
        }
    };

    stopPolling = () => {
        clearInterval(this.checkChangeTimer);
    };
}
